import React from 'react';
import { Provider } from 'react-redux';

import configureStore from '../store/pipelineSlidingPaneStore';
import PipelineSlidingPaneContainer from '../containers/PipelineSlidingPaneContainer';

// See documentation for https://github.com/reactjs/react-redux.
// This is how you get props from the Rails view into the redux store.
// This code here binds your smart component to the redux store.
const PipelineSlidingPaneApp = (props) => (
  <Provider store={configureStore(props)}>
    <PipelineSlidingPaneContainer />
  </Provider>
);

export default PipelineSlidingPaneApp;
